import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { routes } from "consts";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { useCourse } from "api/hooks";
import { PaziaLoader } from "components/atoms";
import { CourseStudentDocument } from "api/courseStudentsApi";
import { PageMain } from "components/molecules";

export const CourseFormPage = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const { data, loading } = useCourse(Number(courseId));

  if (loading) return <PaziaLoader position="center" />;
  if (!data) return null;

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Kursy", path: routes.COURSES },
          { title: data.data.name, path: routes.COURSES_MANAGE(courseId) },
          { title: "Formularze" },
        ]}
        headerText="Dokumenty"
      />
    </PageMain>
  );
};

const columns = [
  {
    id: "id",
    label: "ID",
  },
  {
    id: "firstName",
    label: "Imię i Nazwisko",
    renderCell: (x: string, row: CourseStudentDocument) => (
      <div className="flex items-center gap-4">
        {row.firstName} {row.surname}
      </div>
    ),
  },
  {
    id: "email",
    label: "Email",
  },
];
